
export enum ArtSubCategoryTitle {
    ALL = "All",
    PAINTINGS = "Paintings",
    CERAMICS = "Ceramics",
    DIGITAL = "Digital Art"
}